'use client';

import StatusPage from '@/components/Common/StatusPage';
import { useEffect } from 'react';

export default function HomeError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Route error boundary:', error);
  }, [error]);

  return (
    <StatusPage
      variant="error"
      onRetry={reset}
      detail={
        process.env.NODE_ENV === 'development'
          ? error.message
          : error.digest
            ? `Codice: ${error.digest}`
            : null
      }
    />
  );
}
